<template><el-drawer
    class="sideDrawer"
    :size="drawerSize"
    :close-on-click-modal="false"
    append-to-body
    destroy-on-close
    title="计费信息维护"
    :visible="detailShow"
    :before-close="beforeCloseDialog"
    @dialogclose="beforeCloseDialog"
  ><i
      class="iconfont icon-back-quanping iconFull"
      @click="drawerSize = '100%'"
      v-if="drawerSize == '70%'"
    />
    <i
      @click="drawerSize = '70%'"
      class="iconfont icon-back-tuichuquanping iconFull"
      v-else
    />
    <div
      slot="title"
      class="dialog-header-title"
    >
      <span class="name">计费信息维护</span>
    </div>
    <div
      class="form_content"
      style="padding: 20px"
    >
      <el-form
        v-if="detailShow"
        :model="formData"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-row class="form_head_title">
          
          租户信息
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="记录编号:"
              prop="maintain_no"
            >
              <el-input
                v-model="formData.maintain_no"
                disabled
                placeholder="保存后自动生成"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="客户名称:"
              prop="customer_name"
            >
              <el-input
                v-model="formData.customer_name"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="产品名称:"
              prop="account_name"
            >
              <el-input
                v-model="formData.account_name"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="目前状态:"
              prop="current_state"
            >
              <el-select
                v-model="formData.current_state"
              style="width: 100%"
                placeholder="请选择"
                disabled
              >
                <el-option
                  v-for="item in cellStatusList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option> </el-select></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="套餐名称:"
              prop="contacts_package"
            >
              <el-select
                v-model="formData.contacts_package"
                placeholder="请选择"
              style="width: 100%"
                @change="comboChange"
              >
                <el-option
                  v-for="item in comboList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form_head_title">
          
          维护内容
        </el-row>
        <el-row>
          <el-col
            :span="12"
            v-if="formData.account_key != 8"
          >
            <el-form-item
              label="开通时间:"
              prop="open_time"
            >
              <el-date-picker
              style="width: 100%"
                v-model="formData.open_time"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="费用到期时间:"
              prop="expire_time"
              v-if="![10, 8, 13].includes(formData.account_key)"
            >
              <el-date-picker
              style="width: 100%"
                v-model="formData.expire_time"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="购买用户数:"
              prop="users_number"
              v-if="[1, 12].includes(formData.account_key)"
            >
              <el-input-number
                :precision="0"
                v-model="formData.users_number"
                :min="0"
                :max="9999999999"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              :label="
                formData.account_key == 13 ? '本次充值项目数:' : '本次充值次数:'
              "
              prop="purchases_number"
              v-if="[3, 10, 8, 13,15].includes(formData.account_key)"
            >
              <el-input-number
                :precision="0"
                v-model="formData.purchases_number"
                :min="-9999999999"
                :max="9999999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="[3, 10, 8, 13,15].includes(formData.account_key)">
          <el-col :span="12">
            <el-form-item
              :label="
                formData.account_key == 13 ? '累计充值项目数:' : '累计充值次数:'
              "
              prop="total_number"
              style="position:relative"
            >
              <span class="tips">({{
                  formData.account_key == 13
                    ? "包含本次充值项目数"
                    : "包含本次充值次数"
                }})</span>
              <el-input-number
                :precision="0"
                v-model="formData.total_number"
                :min="0"
                :max="9999999999"
                disabled
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="累计已使用:"
              prop="total_use"
              v-if="[3, 10, 8, 13,15].includes(formData.account_key)"
            >
              <el-input-number
                :precision="0"
                v-model="formData.total_use"
                :min="0"
                :max="9999999999"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="备注:"
          prop="remark"
        >
          <el-input
            v-model="formData.remark"
            maxlength="3000"
            show-word-limit
            autosize
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="编制人:"
              prop="createByName"
            >
              {{ formData.createByName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="编制时间:"
              prop="createTime"
            >
              {{ formData.createTime }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button
        size="small"
        @click="beforeCloseDialog"
      >取消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="submit"
        :loading="loading"
      >保存</el-button>
    </div>
    <!-- 订单详情 -->
    <order-record
      :show="showOrderRecord"
      :orderId="orderId"
      @closeOrderRecord="closeOrderRecord"
    >
    </order-record>
    <!-- 付款记录 -->
    <payment-record
      :show="showPaymentRecord"
      :paymentId="paymentId"
      :isCancle="isCancle"
      @closePaymentRecord="closePaymentRecord"
    >
    </payment-record>
  </el-drawer>
</template>

<script>
import utils from '@/utils.js'
import * as constants from '../billingCenter/constants'
import PaymentRecord from '../billingCenter/paymentRecord.vue'
import OrderRecord from '../billingCenter/orderRecord.vue'
import moment from 'moment'
export default {
  components: {
    PaymentRecord,
    OrderRecord
  },
  data() {
    return {
      drawerSize: '70%',
      comboList: [],
      isCancle: false,
      showPaymentRecord: false,
      paymentId: '',
      showOrderRecord: false,
      orderId: '',
      detailShow: false,
      formData: {
        maintain_no: '',
        customer_name: '',
        customer_id: '',
        account_key: '',
        account_name: '',
        current_state: '',
        contacts_package: '',
        open_time: '',
        expire_time: '',
        users_number: 0,
        purchases_number: 0,
        total_use: 0,
        total_number: 0,
        remark: '',
        createByName: '',
        createTime: ''
      },
      rules: {
        open_time: [
          {
            required: true,
            message: '请选择开通时间',
            trigger: ['blur', 'change']
          }
        ],
        expire_time: [
          {
            required: true,
            message: '请选择费用到期时间',
            trigger: ['blur', 'change']
          }
        ],
        users_number: [
          {
            required: true,
            message: '请输入购买用户数',
            trigger: ['blur', 'change']
          }
        ],
        purchases_number: [
          {
            required: true,
            message: '请输入本次充值次数',
            trigger: ['blur', 'change']
          }
        ],
        remark: [
          {
            required: false,
            max: 3000,
            message: '字数不得超过3000',
            trigger: ['blur', 'change']
          }
        ]
      },
      total_recharge: 0,
      ...constants,
      accountList: [],
      loading: false
    }
  },
  props: ['show', 'data', 'customer'],
  watch: {
    'formData.account_key': {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal && newVal != '' && newVal != oldVal) {
          this.getCombo(newVal)
        }
      }
    },

    'formData.purchases_number': {
      handler(newVal, oldVal) {
        if ((newVal || newVal == 0) && newVal != oldVal) {
          if (
            this.formData &&
            (this.formData.account_key == 3 || this.formData.account_key == 10 || this.formData.account_key == 8 || this.formData.account_key == 13)
          ) {
            this.formData.total_number = Number(newVal) + Number(this.total_recharge)
          }
        }
      },
      deep: true,
      immediate: true
    },
    show: {
      handler(newVal, oldVal) {
        this.detailShow = newVal
      },
      deep: true,
      immediate: true
    },
    customer: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.customer_name = newVal.name
          this.formData.customer_id = newVal.id
        }
      },
      deep: true,
      immediate: true
    },
    data: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (newVal.account_module === 1) {
            this.formData.account_name = '软件基础模块'
          } else if (newVal.account_module === 2) {
            this.formData.account_name = 'BI模块充'
          } else if (newVal.account_module === 3) {
            this.formData.account_name = '企查查基础数据'
          } else if (newVal.account_module === 4) {
            this.formData.account_name = '企查查风险监控'
          } else if (newVal.account_module === 5) {
            this.formData.account_name = '进项发票推送'
          } else if (newVal.account_module === 6) {
            this.formData.account_name = '凭证推送'
          } else if (newVal.account_module === 7) {
            this.formData.account_name = '支付宝接口'
          } else if (newVal.account_module === 8) {
            this.formData.account_name = 'OCR'
          } else if (newVal.account_module === 9) {
            this.formData.account_name = '银企直连'
          } else if (newVal.account_module === 10) {
            this.formData.account_name = 'E签宝'
          } else if (newVal.account_module === 12) {
            this.formData.account_name = '新筑课堂'
          } else if (newVal.account_module === 13) {
            this.formData.account_name = '钉钉考勤接口'
          }else if (newVal.account_module === 15) {
            this.formData.account_name = '天眼查'
          }
          this.formData.account_key = newVal.account_module
          this.getStatus(this.formData.account_key)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    if (!this.isView) {
      this.formData.createTime = utils.formatDate(new Date())
      this.formData.createByName = this.$store.state.login.currentUser.username
      this.formData.createBy = this.$store.state.login.currentUser.userId
    }
  },
  methods: {
    //根据产品查询套餐内容
    getCombo(types) {
      this.comboList = []
      this.$http.get('${third}/account/third_combo/getComboByAccountModule/' + types + '?tenantId=-1').then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            this.comboList.push({
              name: item.combo_name,
              code: item.id,
              price: item.price,
              times: item.times,
              user_num: item.user_num,
              year: item.year
            })
          })
        }
      })
    },
    //订单付款记录关闭
    closePaymentRecord() {
      this.showPaymentRecord = false
    },
    //订单付款记录
    paymentRecord(id, status) {
      this.isCancle = false
      this.paymentId = ''
      if (id) {
        this.paymentId = id
      }
      if (status == '3') {
        this.isCancle = true
      }
      this.showPaymentRecord = true
    },
    //订单详情关闭
    closeOrderRecord() {
      this.showOrderRecord = false
    },
    //订单详情
    orderRecord(id) {
      this.orderId = ''
      if (id) {
        this.orderId = id
      }
      this.showOrderRecord = true
    },
    // 获取订单信息
    getDetail(id) {
      this.$http.get('${third}/costcenter/third_order/' + id).then((res) => {
        if (res.data) {
          res.data.id = ''
          res.data.open_time = ''
          res.data.expire_time = ''
          res.data.users_number = 0
          res.data.purchases_number = 0
          res.data.total_number = 0
          res.data.total_use = 0
          res.data.remark = ''
          this.formData = res.data
        }
      })
    },
    //获取产品状态
    getProStatus(id) {
      this.$http.get('${third}/system/account_mangement/getById?tenantId=' + id).then((res) => {
        if (res.data) {
          const accountStatus = res.data
          if (this.formData.account_key) {
            let indexs = this.formData.account_key
            accountStatus.forEach((item) => {
              if (item.account_module == indexs) {
                if (item.account_module == indexs) {
                  if (this.isEnough(item)) {
                    this.$set(this.formData, 'current_state', 0)
                  } else if (this.isArrears(item)) {
                    this.$set(this.formData, 'current_state', 2)
                  } else {
                    this.$set(this.formData, 'current_state', 1)
                  }
                }
              }
            })
          }
        }
      })
    },
    getStatus(item) {
      if (item)
        this.$http
          .get('${third}/system/account_mangement/getByTenantIdAndModule?id=' + this.formData.customer_id + '&accountModule=' + Number(item))
          .then((res) => {
            if (res.data) {
              this.total_recharge = res.data.total_recharge
              this.$set(this.formData, 'total_use', res.data.total_times)
              this.$set(this.formData, 'total_number', res.data.total_recharge)
              this.getProStatus(this.formData.customer_id)
            }
          })
    },
    // 是否余额不足
    isEnough(module) {
      let enDays = module.remainDays < 30 && module.remainDays > 0
      let enUser = module.total_user !== null && module['total_user'] - module['userCount'] < 30 && module['total_user'] - module['userCount'] > 0
      let enTimes =
        module.total_times !== null && module['total_recharge'] - module['total_times'] < 100 && module['total_recharge'] - module['total_times'] > 0
      return enDays || enUser || enTimes
    },
    // 是否欠费
    isArrears(module) {
      let enDays = module.remainDays < 1
      let enUser = module.total_user !== null && module['total_user'] - module['userCount'] < 1
      let enTimes = module.total_times !== null && module['total_recharge'] - module['total_times'] < 1
      return enDays || enUser || enTimes
    },
    // 相差时间
    DateDiff(sDate1, sDate2) {
      let aDate, oDate1, oDate2, iDays
      aDate = sDate1.split('-')
      oDate1 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0]) //转换为12-18-2002格式
      aDate = sDate2.split('-')
      oDate2 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0])
      iDays = parseInt((oDate1 - oDate2) / 1000 / 60 / 60 / 24) //把相差的毫秒数转换为天数
      return iDays
    },

    //关闭dialog
    beforeCloseDialog() {
      this.detailShow = false
      this.$emit('closeMaintainDialog')
    },
    //客户选择器同时绑定客户id
    customerChange(val) {
      this.accountList.forEach((item) => {
        if (item.name == val) {
          this.formData.customer_id = item.code
        }
      })
    },
    comboChange() {},

    //提交数据
    submit() {
      this.loading = true
      this.$refs.ruleForm.validate((valid) => {
        this.$set(this.formData, 'refId', this.refId)
        if (valid) {
          this.$http.post('${third}/costcenter/third_maintain/', this.formData).then(
            (res) => {
              if (res.data.state) {
                this.$message.success('保存成功！')
                this.loading = false
                this.$emit('closeMaintainDialog', true)
              }
            },
            (error) => {
              this.loading = false
              reject(error)
            }
          )
        } else {
          this.loading = false
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.dialog-header-title {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.dialog-header-title > span {
  border-left: 3px solid #2761ff;
  font-weight: 700;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}
/deep/.el-dialog__body {
  padding: 10px 20px 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.botton_button {
  display: flex;
  text-align: center;
  justify-content: center;
}
.form_head_title {
  height: 35px;
  color: #377cff;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.tips {
  color: rgba(199, 199, 199, 100);
  font-size: 12px;
  position: absolute;
  left: -110px;
  top: 16px;
}
.detailBtn {
  color: #377cff;
  cursor: pointer;
}
</style>
